import {ApprovalStatusType} from "@app/shared/enums/approval-status-type.enum";
import {DocFile} from "@app/shared/classes/doc-file";

export class AbstractRequestEntity {
  approvedBy: string;
  approvedOn: Date;
  responseMessage: string;
  currentStatus: ApprovalStatusType;

  name: string;
  txnTypeId: number;
  docFile: DocFile;
  editable: boolean;
  submittedOn: Date;

  submittedById: number;
  submittedForId: number;
  docFileId: number;
}
